import axios, { AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { UserModule } from '@/store/modules/user/user.store';
import { RealmsModule } from '@/store/modules/realms/realms.store';
import signalRService from '@/services/signalR/signalR.service';
import { CustomHeaders } from '@/core/constants';
import HttpStatus from 'http-status-codes';

const responseHandler = async(response: AxiosResponse) => {
    const responseStatus = response.status;

    const tokenExpired = response?.headers[CustomHeaders.TokenExpired] as boolean;
    if (tokenExpired) {
        UserModule.Reset();
        location.reload();
    }

    const token = response?.headers[CustomHeaders.Token] as string;
    if (token) {
        await UserModule.RefreshToken(token);
    }

    if (responseStatus === HttpStatus.UNAUTHORIZED && token) {
        try {
            // Token refreshed succesfully, make request again
            const retryResponse = await axios.request(response.config);
            return retryResponse;
        } catch (e) {
            UserModule.Reset();
            location.reload();
        }
    }

    return response;
};

const requestHandler = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
    if (config.headers) {
        if (UserModule.Token) {
            config.headers.Authorization = `Bearer ${UserModule.Token}`;
        }

        config.headers['x-titans-realm'] = RealmsModule.activeRealmId;

        if (signalRService.connectionId) {
            config.headers['x-connection-id'] = signalRService.connectionId;
        }
    }

    return config;
};

export {
    requestHandler,
    responseHandler
};
